import React from "react";
import { ChatContainer } from "@/components/ChatContainer";
import Footer from "../components/footer/Footer";
import InitAuth from "../components/InitAuth";
import LauncherButton from "@/components/launcher/LauncherButton";
import SocketProvider from "../lib/client/contexts/SocketContext";
import { ConversationsProvider } from "../lib/client/contexts/ConversationsContext";
import { BlobsProvider } from "../lib/client/contexts/BlobsContext";
import { LayoutProvider } from "../lib/client/contexts/LayoutContext";
import { useLauncherStore } from "../../lib/client/contexts/LauncherStoreContext";
import { getMessengerToken } from "@/lib/client/utils/config";
import { HelpCenterProvider } from "../lib/client/contexts/HelpCenterContentContext";
import { BusinessHoursProvider } from "../lib/client/contexts/BusinessHoursContext";
import { OverlayProvider } from "../lib/client/contexts/OverlayContext";

export default function TabsLayout({
  params,
  children,
}: {
  params: { tenantId: string; messengerId: string; hostConfig: string; locale: string };
  children: React.ReactNode;
}) {
  const config = useLauncherStore((state) => state.config);
  const messengerToken = getMessengerToken(params.hostConfig);

  return (
    <>
      <InitAuth
        tenantId={params.tenantId}
        messengerId={params.messengerId}
        messengerToken={messengerToken}
      >
        <ConversationsProvider tenantId={params.tenantId}>
          <BusinessHoursProvider>
            <HelpCenterProvider>
              <BlobsProvider>
                <SocketProvider
                  tenantId={params.tenantId}
                  messengerId={params.messengerId}
                  messengerToken={messengerToken}
                >
                  <LayoutProvider>
                    <ChatContainer messengerId={params.messengerId}>
                      <OverlayProvider messengerId={params.messengerId}>
                        {children}
                        <Footer
                          hidePoweredBy={config?.settings?.displaySettings?.hidePoweredBy}
                          params={params}
                        />
                      </OverlayProvider>
                    </ChatContainer>
                  </LayoutProvider>
                </SocketProvider>
              </BlobsProvider>
            </HelpCenterProvider>
          </BusinessHoursProvider>
          <LauncherButton params={params} messengerId={params.messengerId} isAuth />
        </ConversationsProvider>
      </InitAuth>
    </>
  );
}
